export class RequiredTrigger
{
    static bind(input)
    {
        input.addEventListener('change', () => {
            input.required = input.offsetParent != null;
        });
    }
}